import React from "react";
import RimFilters from "./Rim-Filter";
import RimMetricsContainer from "./RimMetricsContainer";
import RimWidgets from "./Rim-widgets/Rim-Widgets";
import "./Rim.css"
function Rim() {
    return (
     

        
           <div className="Rim-tab" style={{height:"100vh"}}>
            < RimFilters/>
            < RimMetricsContainer/>
            
            <RimWidgets/>
            </div>
       
    )
}

export default Rim;



